import React from 'react';
import './HeroSection.css';

function HeroSection() {
  return (
    <section className="hero-section">
      <h1>
        Leading manufacturers of reliable food and fruit processing machinery
        <span className="hero-highlight"> Since 1996.</span>
      </h1>
    </section>
  );
}

export default HeroSection; 